const defaults = ["m", "mmnmmommommnonmmonqnmmo", "abcdefghijklmnopqrstuvwxyzyxwvutsrqponmlkjihgfedcba", "mmmmmaaaaammmmmaaaaaabcdefgabcdefg", "mamamamamama", "jklmnopqrstuvwxyzyxwvutsrqponmlkj", "nmonqnmomnmomomno", "mmmaaaabcdefgmmmmaaaammmaamm", "mmmaaammmaaammmabcdefaaaammmmabcdefmmmaaaa", "aaaaaaaazzzzzzzz", "mmamammmmammamamaaamammma", "abcdefghijklmnopqrrqponmlkjihgfedcba", "mmnnmmnnnmmnn"];

export function lightStylePatterns(entities) {
    const patterns = new Map();
    for (const entity of entities) {
        if (!["light", "light_spot", "light_dynamic"].includes(entity.classname)) continue;
        const style = Number(entity.style) || 0;
        if (style >= 32 || entity.pattern) patterns.set(style,
            ["light", "light_spot"].includes(entity.classname) && (Number(entity.spawnflags) & 1) ? "a" : entity.pattern || "m");
    }
    return patterns;
}

export function lightStyleValue(style, seconds, patterns) {
    const pattern = patterns.get(style) ?? defaults[style] ?? "m";
    return (pattern.charCodeAt(Math.floor(seconds * 10) % pattern.length) - 97) / 12;
}
